<template>
  <div class="contact">
    <div class="boxwrap">
      <div class="rounded detailBox shadow">
        <h2>Your full name</h2>
        <input class="input" placeholder="Firstname Lastname" v-model.trim="name" />
        <h2>Phone number</h2>
        <input class="input" placeholder="include any region code" inputmode="numeric" pattern="[0-9]*" v-model.trim="number" />
        <h2>Email address</h2>
        <input class="input" placeholder="example@email.com" v-model.trim="email" />
      </div>
    </div>
    <div class="buttonBar">
      <div @click="$router.go(-1)" class="button Enabled">
        <h3>Back</h3>
      </div>
      <div @click="process" :class="contactValid ? 'button Enabled' : 'button Disabled'">
        <h3>Process</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      name: null,
      number: null,
      email: null
    };
  },
  computed: {
    contactValid: function() {
      let ret =
        this.name &&
        this.number &&
        this.email &&
        this.name.length > 3 &&
        this.number.length > 5 &&
        this.validateEmail(this.email);
      return ret;
    }
  },
  methods: {
    validateEmail: function(mail) {
      if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,13})+$/.test(mail)) {
        return true;
      }
      return false;
    },
    process: function() {
      if (!this.contactValid) {
        return;
      }
      this.$store.dispatch("setContact", {
        name: this.name,
        number: this.number,
        email: this.email
      });
      this.$router.push("decide");
    }
  }
};
</script>

<style lang="scss" scoped>
.input {
  border-radius: 7px;
  border: solid var(--base-colour, #535450) 2px;
  margin-top: -1em;
}
.row {
  display: grid;
  grid-template-columns: 1fr 1fr;

  width: 100%;
  text-align: right;
  .response {
    text-align: center;
  }
}
.table {
}

.buttonBar {
  display: flex;
  justify-content: space-evenly;
  width: 100%;
  margin-bottom: 50px;
  @media (max-width: 550px) {
    margin-bottom: 5px;
  }
}

.contact {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: column;
  padding-top: -50px;
}
.boxwrap {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 2;
  width: 100%;
  margin-top: 2em;
  margin-bottom: 2em;
}
</style>